import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <div className="about-container">
        <h1>About Us</h1>
        <div className="about-content">
          <section>
            <h2>Welcome to FeatureMap</h2>
            <p>
              FeatureMap is a comprehensive feature management platform designed to help 
              product teams organize, track, and prioritize product features throughout 
              their development lifecycle.
            </p>
          </section>

          <section>
            <h2>Our Mission</h2>
            <p>
              Our mission is to provide teams with a powerful yet intuitive tool for 
              managing product features, enabling better collaboration between internal 
              teams and customers, and ensuring that the most important features are 
              delivered first.
            </p>
          </section>

          <section>
            <h2>Key Features</h2>
            <ul>
              <li><strong>Hierarchical Feature Organization:</strong> Organize features in a tree structure to capture relationships and dependencies.</li>
              <li><strong>Release Management:</strong> Plan and track features across multiple releases with status tracking.</li>
              <li><strong>Tagging System:</strong> Categorize and filter features using custom tags and keywords.</li>
              <li><strong>Voting & Rating:</strong> Engage customers and stakeholders through voting and rating systems.</li>
              <li><strong>Documentation Links:</strong> Connect features to existing documentation and resources.</li>
              <li><strong>Role-Based Access:</strong> Control access with Owner, Editor, and Guest roles.</li>
            </ul>
          </section>

          <section>
            <h2>Who We Are</h2>
            <p>
              FeatureMap was created by OpenWonder LLC, which is the brain child of Michael 
              Holland, a long-time product manager and internet innovator who has been making
               web applications for 30 years (really! the first one was "World Famous Comics" 
               an online comic site in 1994). In working on over 500 projects, he has
              experienced firsthand the challenges of managing complex product roadmaps and the 
              hazards in getting feedback in B2B2E(mployee) environments. 
              He built this platform to solve the common problems teams face when trying 
              to organize, prioritize, and communicate about product features in an age where AI can help 
              speed up the process and get more organized and useful feedback.
            </p>
          </section>

          <section>
            <h2>How It Works</h2>
            <p>
              FeatureMap allows you to create feature groups (also called "Feature Maps") 
              where you can organize your product features hierarchically. Each feature 
              can have sub-features, be tagged, assigned to releases, and linked to 
              documentation. Team members can be assigned different roles (Owner, Editor, 
              or Guest) to control who can make changes.
            </p>
            <p>
              For customer-facing feature maps, you can enable voting and rating systems 
              to gather feedback and prioritize based on what matters most to your users.
            </p>
          </section>

          <section>
            <h2>Contact Us</h2>
            <p>
              If you have questions, feedback, or need support, please reach out to us 
              through your account administrator or contact your feature group owner. 
              For technical support or feature requests, please contact your system 
              administrator.
            </p>
          </section>

          <div className="about-footer">
            <Link to="/" className="back-link">
              <i className="fas fa-arrow-left"></i> Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;

